import styled, {css} from 'styled-components';

/*
 * Constants.
 */

export const DROPDOWN_ITEM_DISABLED_OPACITY = 0.5;

/*
 * Style.
 */

interface StyleProps {
  $shouldReserveRightIcon?: boolean;
}

export const dropdownItemHoverBackgroundColor = css`
  background-color: ${(p) => p.theme.alphas.gray10};

  ${(p) =>
    p.theme.hasDropdownRedesign &&
    css`
      background-color: ${p.theme.background.surface.tertiaryHover};
    `}
`;

export const StyledDropdownItemDiv = styled.div<StyleProps>`
  display: grid;
  grid-template-columns: auto auto 1fr auto ${(p) => (p.$shouldReserveRightIcon ? '24px' : 'auto')};
  grid-template-areas: 'left-icon content secondary-content badges right-icon';
  justify-items: start;

  padding: ${(p) => (p.theme.hasDropdownRedesign ? '6px 8px' : '5px 12px')};

  &:hover,
  &:focus-within,
  &:active,
  &[aria-selected='true'] {
    ${dropdownItemHoverBackgroundColor}
  }

  &:disabled,
  &[aria-disabled='true'] {
    opacity: ${DROPDOWN_ITEM_DISABLED_OPACITY};
    background-color: ${(p) => p.theme.alphas.transparent};
  }

  ${(p) =>
    p.theme.hasDropdownRedesign &&
    css`
      border-radius: 4px;

      background-color: ${p.theme.alphas.transparent};
      color: ${p.theme.textStyles.default};
    `}
`;

/**
 * Pins a grid child to the top of rows whose content sets `data-dropdown-item-has-secondary-line="true"`.
 * Prefer `dropdownItemEdgeControlAlignmentStyles`; use this alone on a wrapper around an element that already has it.
 */
export const dropdownItemEdgeControlFirstLineAlignmentOverride = css`
  ${(p) =>
    p.theme.hasDropdownRedesign &&
    css`
      ${StyledDropdownItemDiv}:has([data-dropdown-item-has-secondary-line='true']) & {
        align-self: start;
      }
    `}
`;

/** Lines an icon or selection control up with the dropdown item's title line. */
export const dropdownItemEdgeControlAlignmentStyles = css`
  ${dropdownItemEdgeControlFirstLineAlignmentOverride}

  ${(p) =>
    p.theme.hasDropdownRedesign &&
    css`
      /* Matches the line height of the body-regular title; keep in sync if the title variant changes. */
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;
